import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { tourismClassifiedAPIRoutes } from '../index';

export const systemConfigServices = createApi({
  reducerPath: 'systemConfigServices',
  tagTypes: ['SystemConfigTag'],
  baseQuery: fetchBaseQuery({
    baseUrl: tourismClassifiedAPIRoutes.baseUrl,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('jwtToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  endpoints: (builder) => ({
    getAllConfigs: builder.query<Record<string, string>, void>({
      query: () => ({
        url: `system-config/all`,
        method: 'GET'
      }),
      providesTags: ['SystemConfigTag']
    }),
    updateConfigs: builder.mutation<boolean, Record<string, string>>({
      query: (body) => ({
        url: `system-config/update`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['SystemConfigTag']
    })
  })
});

export const {
  useGetAllConfigsQuery,
  useUpdateConfigsMutation
} = systemConfigServices;
